import { SchoolPortalShell, type SectionCode } from "@/client/components/school-portal/PortalShell";
import { ContactpersonenSection } from "@/client/components/school-portal/sections/ContactpersonenSection";
import { GroepenSection } from "@/client/components/school-portal/sections/GroepenSection";
import { VerhinderingenSection } from "@/client/components/school-portal/sections/VerhinderingenSection";
import { ControlerenSection } from "@/client/components/school-portal/sections/ControlerenSection";

function renderSection(code: SectionCode, schoolId: number) {
  switch (code) {
    case "contactgegevens":
      return <ContactpersonenSection schoolId={schoolId} />;
    case "groepen":
      return <GroepenSection schoolId={schoolId} />;
    case "studiedagen":
      return <VerhinderingenSection schoolId={schoolId} />;
    case "controleren":
      return <ControlerenSection schoolId={schoolId} />;
  }
}

export function SchoolPortalPage() {
  return <SchoolPortalShell renderSection={renderSection} />;
}
